<template>
  <BaseContainer>
    <v-content slot="principal">
      <div class="main-container">
      <div v-if="showPrice" class="left-time-banner text-center white--text">
        <v-icon class="mr-1">mdi-clock-outline</v-icon>
        <div class="mr-4 left-time">
          <b>{{ formatTime(countdownTime) }}</b>
        </div>
        <span class="old-price mr-2">R$ 197,00</span>
        <span class="promo-price">R$ {{ getPrice }},00</span>
      </div>

      <v-container>
        <Hero />

        <div id="como-funciona" ref="howWork" v-lazy-intersect="loadHowWork">
          <component :is="HowWorkComponent" v-if="showHowWork" class="section" />
        </div>

        <PainsSection class="section" />

        <div ref="cardapio" v-lazy-intersect="loadCardapio">
          <component :is="CardapioComponent" v-if="showCardapio" class="section" />
        </div>

        <div ref="benefits" v-lazy-intersect="loadBenefits">
          <component :is="BenefitsComponent" v-if="showBenefits" class="section" />
        </div>

        <div ref="gestor" v-lazy-intersect="loadGestor">
          <component :is="GestorComponent" v-if="showGestor" class="section" />
        </div>

        <div id="recursos">
          <ResourcesSection class="section" />
        </div>

        <!-- <MassWhatsappSection class="section" /> -->


        <DemoCarousel class="section" />

        <PricingSection v-if="showPlanos" id="planos" class="section" />

        <div id="depoimentos">
          <TestimonialsCarousel class="section" />
        </div>

        <div id="faq">
          <Faq class="section" />
        </div>

        <GuaranteeSection class="section" />

        <BrdeLabsAwardSection class="section" />

      </v-container>
      </div><!-- /.main-container -->

      <Footer />

      <v-btn
        v-if="!hideWhatsapp"
        id="whatsapp-button"
        fab
        x-large
        color="success"
        :class="[
          'whatsapp-button',
          { 'shake-animation': animateWhatsappButton },
        ]"
        @click="onClick"
      >
        <v-icon x-large>mdi-whatsapp</v-icon>
        <span class="badge-notification">1</span>
      </v-btn>
    </v-content>
  </BaseContainer>
</template>

<script>
  // import MoreResourcesSection from '@/components/MoreResourcesSection.vue';
  import MassWhatsappSection from '@/components/MassWhatsappSection.vue';
  // import ReportsSection from '@/components/ReportsSection.vue';
  // import StopWastingTimeSection from '@/components/StopWastingTimeSection.vue';
  // import OrderProcessStepsSection from '@/components/OrderProcessStepsSection.vue';
  // import BonusSection from '@/components/BonusSection.vue';

  import Hero from '@/components/Hero.vue';
  import BaseContainer from '@/components/BaseContainer.vue';
  import Footer from '@/components/Footer.vue';
  import DemoCarousel from '@/components/DemoCarousel.vue';
  import Faq from '@/components/Faq.vue';
  import ResourcesSection from '@/components/ResourcesSection.vue';
  import PainsSection from '@/components/PainsSection.vue';
  import PricingSection from '@/components/PricingSection.vue';
  import TestimonialsCarousel from '@/components/TestimonialsCarousel.vue';
  import GuaranteeSection from '@/components/GuaranteeSection.vue';
  import BrdeLabsAwardSection from '@/components/BrdeLabsAwardSection.vue';
  import { mapState } from 'vuex';
  import scrollDepthMixin from '@/utils/useScrollDepth';
  import { trackClick } from '@/utils/lpTracker';

  export default {
    name: 'Home',

    mixins: [scrollDepthMixin],

    components: {
      BaseContainer,
      Hero,
      ResourcesSection,
      DemoCarousel,
      PainsSection,
      PricingSection,
      TestimonialsCarousel,
      GuaranteeSection,
      BrdeLabsAwardSection,
      MassWhatsappSection,
      Footer,
      Faq,
    },

    data: () => ({
      animateWhatsappButton: false,
      // countdownTime: 2 * 60 * 60 + 59 * 60 + 59, // 23h 59m 59s em segundos
      countdownTime: 30 * 60 + 59, // 30m 59s em segundos
      showHowWork: false,
      showCardapio: false,
      showBenefits: false,
      showGestor: false,
      HowWorkComponent: null,
      CardapioComponent: null,
      BenefitsComponent: null,
      GestorComponent: null,
    }),

    mounted() {
      const storedTime = parseInt(localStorage.getItem('countdownTime'), 10);
      const storedTimestamp = parseInt(localStorage.getItem('countdownTimestamp'), 10);
      const now = Math.floor(Date.now() / 1000);

      if (!isNaN(storedTime) && !isNaN(storedTimestamp)) {
        const elapsed = now - storedTimestamp;
        const remaining = storedTime - elapsed;
        this.countdownTime = remaining > 0 ? remaining : 0;
      }

      this.startCountdown();

      this.$root.$on('ctaButtonClick', this.ctaButtonClick);

      if (!this.hideWhatsapp) {
        setTimeout(() => {
          this.startAnimation();
          this.showBadge();
        }, 8000);
      }
    },

    directives: {
      lazyIntersect: {
        inserted(el, binding) {
          const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
              binding.value();
              observer.unobserve(el);
            }
          });
          observer.observe(el);
        },
      },
    },

    computed: {
      ...mapState([
        'plan',
        'hideWhatsapp',
        'showPlanos',
      ]),

      getPrice() {
        return this.plan.price;
      },

      showPrice() {
        return this.plan.price > 0;
      },
    },

    methods: {
      loadHowWork() {
        this.showHowWork = true;
        import('@/components/HowWorkVideo.vue').then(m => this.HowWorkComponent = m.default);
      },

      loadCardapio() {
        this.showCardapio = true;
        import('@/components/CardapioDigitalVideo.vue').then(m => this.CardapioComponent = m.default);
      },

      loadBenefits() {
        this.showBenefits = true;
        import('@/components/BenefitsSection.vue').then(m => this.BenefitsComponent = m.default);
      },

      loadGestor() {
        this.showGestor = true;
        import('@/components/GestorPedidosVideo.vue').then(m => this.GestorComponent = m.default);
      },

      startCountdown() {
        this.countdownInterval = setInterval(() => {
          if (this.countdownTime > 0) {
            this.countdownTime--;

            const now = Math.floor(Date.now() / 1000);

            localStorage.setItem('countdownTime', this.countdownTime);
            localStorage.setItem('countdownTimestamp', now);
          }
        }, 1000);
      },

      formatTime(seconds) {
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const sec = seconds % 60;

        return `${String(hrs).padStart(2, '0')}h ${String(mins).padStart(2, '0')}m ${String(sec).padStart(2, '0')}s`;
      },

      ctaButtonClick() {
        if (this.showPrice) {
          this.scrollToPricing();
        } else {
          this.goToWhatsappForm();
        }
      },

      goToWhatsappForm() {
        this.$router.push({ path: 'whatsapp' });
      },

      scrollToPricing() {
        const pricingSection = document.querySelector('#pricing-section');
        if (pricingSection) {
          const offset = -50;
          const targetPosition = pricingSection.getBoundingClientRect().top + window.scrollY + offset;

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth',
          });
        }
      },

      startAnimation() {
        const btn = document.querySelector('#whatsapp-button');
        const isHidden = btn?.classList.contains('hidden');

        if (!isHidden) {
          this.animateWhatsappButton = true;
          setTimeout(() => {
            this.animateWhatsappButton = false;
          }, 80 * 8);
        }

        setInterval(() => {
          const isHidden = btn?.classList.contains('hidden');
          if (!isHidden) {
            this.animateWhatsappButton = true;
            setTimeout(() => {
              this.animateWhatsappButton = false;
            }, 80 * 8);
          }
        }, 12000);
      },

      showBadge() {
        const badge = document.querySelector('.badge-notification');
        if (badge) {
          badge.style.display = 'block';
        }
      },

      onClick() {
        trackClick('Home - WhatsApp floating button');
        this.$router.push({ path: 'whatsapp' });
      },
    },
  };
</script>

<style scoped lang="scss">
  .main-container {
    margin: 12px 3% 0 3%;
  }

  .flex-container {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
    list-style: none;
  }

  .whatsapp-button {
    z-index: 999;
    position: fixed;
    bottom: 30px;
    right: 30px;
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  .whatsapp-button.hidden {
    opacity: 0;
    transform: scale(0.8);
    pointer-events: none;
  }

  @keyframes shake {
    0%,
    100% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(-10px);
    }
    50% {
      transform: translateX(10px);
    }
    75% {
      transform: translateX(-10px);
    }
  }

  .shake-animation {
    animation: shake 0.2s;
    animation-iteration-count: 2;
  }

  .badge-notification {
    position: absolute;
    top: -20px;
    right: 0;
    background-color: red;
    color: white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: none;
    align-items: center;
    justify-content: center;
    font-size: 12px;
  }

  .section {
    margin-top: 72px;
    padding-top: 72px;
    border-top: 1px solid var(--card-border);

    @media (max-width: 780px) {
      margin-top: 48px;
      padding-top: 48px;
    }
  }

  .left-time-banner {
    background-color: #4CAF50; /* cor da faixa */
    padding: 4px 0;
    margin: 0 -12px;
    top: 0;
    font-size: 14px;
    font-weight: 500;
    position: fixed;
    width: 100%;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .old-price {
    text-decoration: line-through;
    opacity: 0.6;
    font-size: 16px;
    margin-right: 8px;
  }

  .promo-price {
    font-weight: bold;
    font-size: 20px;
    color: #fff; /* Ou outro tom se quiser destacar mais */
  }

  .left-time {
    min-width: 100px;
  }
</style>
